import { render, staticRenderFns } from "./foot-path.vue?vue&type=template&id=028936a2&scoped=true&"
import script from "./foot-path.vue?vue&type=script&lang=js&"
export * from "./foot-path.vue?vue&type=script&lang=js&"
import style0 from "./foot-path.vue?vue&type=style&index=0&id=028936a2&lang=scss&scoped=true&"
import style1 from "./foot-path.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028936a2",
  null
  
)

export default component.exports